import { useLayoutEffect } from 'react';
import { useNavigation } from 'expo-router';

import { useResponsive } from '@garnish/core';

import { HorizontalSafeAreaHeaderBackground } from '../../components/HorizontalSafeAreaHeaderBackground';
import { SCREEN_HEADER_OPTIONS } from '../../routing/constants/options';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Continues the `HorizontalSafeAreaContainer` side borders into the native header on compact
 * screens. Larger screens get the default header options back, since the native stack still
 * draws a header background while the header itself is hidden.
 */
export const useHorizontalSafeAreaHeaderOptions = () => {
  const navigation = useNavigation();
  const { currentBreakpoint } = useResponsive();

  // ─── Effects ─────────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    navigation.setOptions(currentBreakpoint.isXS ? HEADER_OPTIONS_XS : HEADER_OPTIONS_SM);
  }, [currentBreakpoint.isXS, navigation]);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const HEADER_OPTIONS_XS = {
  headerBackground: HorizontalSafeAreaHeaderBackground,
  headerStyle: { backgroundColor: 'transparent' },
};

const HEADER_OPTIONS_SM = {
  headerBackground: undefined,
  headerStyle: SCREEN_HEADER_OPTIONS.headerStyle,
};
